import { useEffect } from 'react';

// Lock page scroll while a modal is mounted and restore it on unmount.
// Unlike useModal, this cleans up even when the modal is unmounted directly
// (e.g. after a successful action) instead of toggling a state flag.
const useLockBodyScroll = () => {
    useEffect(() => {
        const html = document.querySelector('html');
        const prevOverflow = html.style.overflow;
        const prevPad = html.style.paddingRight;
        html.style.overflow = 'hidden';
        html.style.paddingRight = '15px';
        return () => {
            html.style.overflow = prevOverflow || 'auto';
            html.style.paddingRight = prevPad || '0';
        };
    }, []);
};

export default useLockBodyScroll;
